import { withCardGate } from '@/src/experiences/card-accounts/withCardGate'
import { MesaCardSkeleton } from './MesaCardSkeleton'
import { CurrentBalanceHighnote } from './CurrentBalanceHighnote'
import { CurrentBalancePlatform } from './CurrentBalancePlatform'
import { GetTheCard } from './GetTheCard'
import * as CardApplication from '@/src/experiences/card-application'
import { YStack } from 'tamagui'
import { DesignSystem } from '@/src/design-system'

export const MesaCard = withCardGate(function ({
  showCardManagement,
  firstCardFetchFinished,
  newestApplication,
  refetchApplicationStatus,
}) {
  DesignSystem.ScreenWideReload.useReloadListener(async () => {
    await refetchApplicationStatus()
  })

  if (!firstCardFetchFinished) {
    return <MesaCardSkeleton />
  }

  if (!newestApplication) {
    return <GetTheCard />
  }

  if (!showCardManagement) {
    switch (newestApplication.platform) {
      case 'HIGHNOTE':
        return (
          <YStack gap="$4">
            <CardApplication.Components.Highnote.ApplicationStatusBanner />
            <GetTheCard />
          </YStack>
        )
      case 'LOANPRO':
        return (
          <YStack gap="$4">
            <CardApplication.Components.ApplicationStatusBanner />
            <GetTheCard />
          </YStack>
        )
      default:
        return null
    }
  }

  switch (newestApplication.platform) {
    case 'HIGHNOTE':
      return <CurrentBalanceHighnote />
    case 'LOANPRO':
      return <CurrentBalancePlatform />
    default:
      return null
  }
})
